import React from "react";
import PropTypes from "prop-types";

const Icon = ({ src: SvgComponent, size = "24px" }) => (
  <SvgComponent
    width={size}
    height={size}
    style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0, backfaceVisibility: "hidden" }}
  />
);

Icon.propTypes = {
  size: PropTypes.string,
  src: PropTypes.elementType.isRequired,
};

export default Icon;
